export default "__VITE_ASSET__BYhen2Wa__"